import { useMemo, useCallback } from 'react';
import { useSelector } from 'react-redux';
import {
    convertIdsToDisplay,
    convertDisplayToIds,
    migrateOldVariableFormat,
    containsVariables,
    extractVariableIds
} from '../../../utils/automation/variableUtils';

/**
 * Variables from Redux + conversion helpers (Automation Studio copy; was ReplayPage).
 */
export const useVariables = () => {
    const { variablesList = [], variablesListDescriptions = {} } = useSelector(
        (state) => state.replay
    );

    const convertToDisplay = useCallback(
        (storedValue) => {
            return convertIdsToDisplay(storedValue, variablesList, variablesListDescriptions);
        },
        [variablesList, variablesListDescriptions]
    );

    const convertToIds = useCallback(
        (displayValue) => {
            return convertDisplayToIds(displayValue, variablesList, variablesListDescriptions);
        },
        [variablesList, variablesListDescriptions]
    );

    const migrateOldFormat = useCallback(
        (value) => {
            return migrateOldVariableFormat(value, variablesList, variablesListDescriptions);
        },
        [variablesList, variablesListDescriptions]
    );

    const hasVariables = useCallback(
        (value) => containsVariables(value),
        []
    );

    const getVariableIds = useCallback(
        (value) => extractVariableIds(value),
        []
    );

    return useMemo(
        () => ({
            variablesList,
            variablesListDescriptions,
            convertToDisplay,
            convertToIds,
            migrateOldFormat,
            hasVariables,
            getVariableIds,
        }),
        [
            variablesList,
            variablesListDescriptions,
            convertToDisplay,
            convertToIds,
            migrateOldFormat,
            hasVariables,
            getVariableIds,
        ]
    );
};

export default useVariables;
